import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const JoinSuccess = () => {
    return (
        <div>
            <Header />
            <div className="page-heading header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Welcome to Creative Lab!</h1>
                            <span>Thank you for joining our tech community</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="callback-form contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-heading">
                                <h2>Application <em>Submitted Successfully!</em></h2>
                                <span>We're excited to have you as part of our community</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="contact-form" style={{ textAlign: 'center', padding: '40px' }}>
                                <div style={{ marginBottom: '30px' }}>
                                    <i className="fa fa-check-circle" style={{ fontSize: '80px', color: '#F4276F', marginBottom: '20px' }}></i>
                                </div>
                                <h3 style={{ color: '#1e1e1e', marginBottom: '20px' }}>Your application has been received!</h3>
                                <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px auto' }}>
                                    Thank you for your interest in joining Creative Lab ISI Ariana. We've received your application and our team will review it carefully. 
                                    You can expect to hear from us within 2-3 business days via email.
                                </p>
                                <div style={{ marginBottom: '30px' }}>
                                    <h4 style={{ color: '#F4276F', marginBottom: '15px' }}>What happens next?</h4>
                                    <ul style={{ textAlign: 'left', maxWidth: '500px', margin: '0 auto', color: '#666' }}>
                                        <li>We'll review your application and background</li>
                                        <li>You'll receive an email confirmation within 24 hours</li>
                                        <li>If accepted, you'll get an invitation to our next orientation session</li>
                                        <li>You'll be added to our community channels and event notifications</li>
                                    </ul>
                                </div>
                                <div style={{ marginTop: '40px' }}>
                                    <a href="/" className="filled-button" style={{ marginRight: '15px' }}>Back to Home</a>
                                    <a href="/AboutUs" className="border-button">Learn More About Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default JoinSuccess;
